<template>
  <div style="background-color: #fff;">
    <center> <img :src="imgUrl" style="width: 100%;margin-bottom: -6px;"></center>
    <h2 style="text-align: center;padding: 15px 0px;font-weight: normal;">资料下载</h2>

    <div class="download_list">
      <ul style="width: 1200px;overflow: auto;margin: auto;">
        <li v-for="(i,k) in dl_infoL"  :key="k" >
          <p style="width: 400px;">{{ i["title"] }}</p> 
          <p>{{ i["time"] }}</p>
          <p>
            <a :href="i['file_url']">下载</a> 
            <img src="../assets/Support/download.svg" width="16px" align="absmiddle"/>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

  export default {
  data() {
      return {
        imgUrl: "",
        dl_infoL: {},
      };
    },
    created() {   
      this.$http.get("api/vue_support/get_downloads_all").then((response) => {
        this.dl_infoL = JSON.parse(response.data.data);
        console.log(this.dl_infoL);
      });
      this.$http.get("api/vue_support/get_support_top_img").then((response) => {
        this.imgUrl = response.data.data
      });
    }
  }
  </script>

<style lang="less" scoped>

.download_list { 

    ul{padding: 10px;}
    li{
      list-style:none;
      line-height: 35px;
      border-bottom: 2px dashed #e2e2e2;
      display: flex;justify-content: space-between; align-items: center
    }
    li:last-child{border-bottom: none;}
    a{ text-decoration: none;font-size: 16px; color: #009BA2;}
    
    
    span{ float: right; font-size: 12px;}
    p { padding-bottom: 2px; }
}

</style>
